import Gender_Male from 'src/assets/Buy_Policy_Images/Gender_Male.svg'
import Gender_Female from 'src/assets/Buy_Policy_Images/Gender_Female.svg'
import Gender_Other from 'src/assets/Buy_Policy_Images/Gender_Non_Binary.svg'
import BMW from 'src/assets/Buy_Policy_Images/CarIcons/bmw.svg'
import Honda from 'src/assets/Buy_Policy_Images/CarIcons/honda.svg'
import Kia from 'src/assets/Buy_Policy_Images/CarIcons/kia.svg'
import Jeep from 'src/assets/Buy_Policy_Images/CarIcons/jeep.svg'
import MG from 'src/assets/Buy_Policy_Images/CarIcons/mg.svg'
import Hyundai from 'src/assets/Buy_Policy_Images/CarIcons/hyundai.svg'
import Mahindra from 'src/assets/Buy_Policy_Images/CarIcons/mahindra.svg'
import Suzuki from 'src/assets/Buy_Policy_Images/CarIcons/maruti-suzuki.svg'
import Mercedes from 'src/assets/Buy_Policy_Images/CarIcons/mercedes-benz.svg'
import Nissan from 'src/assets/Buy_Policy_Images/CarIcons/nissan.svg'
import Renault from 'src/assets/Buy_Policy_Images/CarIcons/renault.svg'
import Toyota from 'src/assets/Buy_Policy_Images/CarIcons/toyota.svg'
import Volkswagen from 'src/assets/Buy_Policy_Images/CarIcons/volkswagen.svg'
import Tata from 'src/assets/Buy_Policy_Images/CarIcons/tata.svg'
import Skoda from 'src/assets/Buy_Policy_Images/CarIcons/skoda.svg'
import feature from 'src/assets/Buy_Policy_Images/feature.svg'
import networkHospital from 'src/assets/Buy_Policy_Images/networkHospital.svg'
import claims from 'src/assets/Buy_Policy_Images/claims.svg'
import FAQ from 'src/assets/Buy_Policy_Images/fAQ.svg'
import videos from 'src/assets/Buy_Policy_Images/videos.svg'
import inPatient from 'src/assets/Buy_Policy_Images/inPatient.svg'
import outPatient from 'src/assets/Buy_Policy_Images/outPatient.svg'
import dayCare from 'src/assets/Buy_Policy_Images/dayCare.svg'
import prePost from 'src/assets/Buy_Policy_Images/prePost.svg'
import maternity from 'src/assets/Buy_Policy_Images/maternity.svg'
import emergencyAmbulance from 'src/assets/Buy_Policy_Images/emergencyAmbulance.svg'
import React from 'react'

export const GENDER_LIST = [
  {
    label: 'Male',
    enum: 'MALE',
    icon: Gender_Male,
  },
  {
    label: 'Female',
    enum: 'FEMALE',
    icon: Gender_Female,
  },
]

export const NOMINEE_GENDER_LIST = [
  {
    label: 'Male',
    enum: 'MALE',
    icon: Gender_Male,
  },
  {
    label: 'Female',
    enum: 'FEMALE',
    icon: Gender_Female,
  },
  {
    label: 'Other',
    enum: 'OTHER',
    icon: Gender_Other,
  },
]

export const OTHER_OPTIONS_LIST = [
  {
    label: 'RENEW',
    description: 'Already have a policy?',
    link: '',
  },
  {
    label: 'TOP UP',
    description: 'Need Top-Up policy?',
    link: '',
  },
  {
    label: 'PORT POLICY',
    description: 'Not Satisfied?',
    link: '',
  },
]

export const MEDICAL_CONDITION_QUESTIONS = [
  {
    label:
      'Have you undergone any surgeries or hospitalizations in the past [insert time period]?',
    subQuestion: [
      { label: 'Are you currently taking any prescription medications?' },
      {
        label: 'Do you smoke or use any tobacco products?',
      },
      {
        label:
          'Have you experienced any major injuries or accidents in the past [insert time period]?',
      },
    ],
  },
  {
    label:
      'Are you currently taking any prescription medications? If yes, please provide details.',
  },
  {
    label:
      'Have you been diagnosed with or received treatment for any chronic illnesses such as diabetes, heart disease, or cancer?',
  },
  {
    label:
      'Have you ever been diagnosed with a mental health disorder or received psychiatric treatment?',
  },
  {
    label:
      'Have you ever been declined for life or health insurance in the past?',
  },
  {
    label: 'Do you smoke or use any tobacco products?',
  },
  {
    label:
      'Have you experienced any major injuries or accidents in the past [insert time period]?',
  },
  {
    label:
      'Are you currently pregnant or planning to become pregnant in the near future?',
  },
  {
    label:
      'Have you had any significant changes in weight or undergone weight loss surgeries?',
  },
]
export const CITY_NAMES = [
  {
    label: 'Hyderabad',
  },
  {
    label: 'Delhi',
  },
  {
    label: 'Mumbai',
  },
  {
    label: 'Chennai',
  },
  {
    label: 'Bengaluru',
  },
  {
    label: 'Pune',
  },
  {
    label: 'Kolkata',
  },
  {
    label: 'Vizag',
  },
]

export const RELATION_TYPE_ENUMS = {
  SELF: 'SELF',
  FATHER: 'FATHER',
  MOTHER: 'MOTHER',
  BROTHER: 'BROTHER',
  SISTER: 'SISTER',
  WIFE: 'WIFE',
  SPOUSE: 'SPOUSE',
  MOTHER_IN_LAW: 'MOTHER_IN_LAW',
  FATHER_IN_LAW: 'FATHER_IN_LAW',
  BROTHER_IN_LAW: 'BROTHER_IN_LAW',
  SISTER_IN_LAW: 'SISTER_IN_LAW',
  SON: 'SON',
  DAUGHTER: 'DAUGHTER',
  GRANDFATHER: 'GRANDFATHER',
  GRANDMOTHER: 'GRANDMOTHER',
  STEPSON: 'STEPSON',
  STEPDAUGHTER: 'STEPDAUGHTER',
}

export const RELATION_TYPES = {
  SELF: 'Self',
  FATHER: 'Father',
  MOTHER: 'Mother',
  BROTHER: 'Brother',
  SISTER: 'Sister',
  WIFE: 'Wife',
  SPOUSE: 'Spouse',
  MOTHER_IN_LAW: 'Mother In Law',
  FATHER_IN_LAW: 'Father In Law',
  SON: 'Son',
  DAUGHTER: 'Daughter',
  GRANDFATHER: 'Grand Father',
  GRANDMOTHER: 'Grand Mother',
  STEPSON: 'Step Son',
  STEPDAUGHTER: 'Step Daughter',
}

export const GENDER_TYPE_ENUMS = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHERS: 'OTHERS',
}

export const SPOUSE_GENDER_TYPE_ENUMS = {
  MALE: 'FEMALE',
  FEMALE: 'MALE',
  OTHERS: 'OTHERS',
}

export const KID_RELATION_TYPE_ENUMS = {
  MALE: RELATION_TYPE_ENUMS.SON,
  FEMALE: RELATION_TYPE_ENUMS.DAUGHTER,
}

export const AGE_COMPONENT_TYPES = {
  me: 'ME',
  spouse: 'SPOUSE',
  kids: 'KIDS',
  parentAndInLaws: 'PARENTS_AND_IN_LAWS',
  parents: 'PARENTS',
  inLaws: 'IN_LAWS',
}

export const PLAN_DETAILS_CORRECT = [
  {
    label: 'Existing Illness cover',
  },
  {
    label: 'In case the sum Insured gets exhausted in a year',
  },
  {
    label: 'Existing Illness cover',
  },
  {
    label: 'In case the sum Insured gets exhausted in a year',
  },
  {
    label: 'Existing Illness cover',
  },
  {
    label: 'Specific Illness cover',
  },
]

export const PLAN_DETAILS_WRONG = [
  {
    label: 'What you should know',
  },
  {
    label: 'A year due to multiple claims or a large claim',
  },
  {
    label: 'In case the sum Insured gets exhausted in a year',
  },
  {
    label: 'Specific Illness cover',
  },
]

export const BUY_CAR_INSURANCE_OPTION_TYPES = {
  noRegistrationNumber: 'NO_REGISTRATION_NUMBER',
  newCar: 'NEW_CAR',
}

export const MOTOR_OPTIONS_LIST = [
  {
    label: 'CLICK HERE',
    description: 'No Reg. No',
    link: '',
    type: 'NO_REGISTRATION_NUMBER',
  },
  {
    label: 'CLICK HERE',
    description: 'Buying a New Car?',
    link: '',
    type: 'NEW_CAR',
  },
]

export const HEALTH_SUM_ASSURED_OPTIONS = [
  {
    title: '1 Lakh',
    value: 100000,
  },
  {
    title: '2 Lakh',
    value: 200000,
  },
  {
    title: '3 Lakh',
    value: 300000,
  },
  {
    title: '4 Lakh',
    value: 400000,
  },
  {
    title: '5 Lakh',
    value: 500000,
  },
  {
    title: '10 Lakh',
    value: 1000000,
  },
  {
    title: '15 Lakh',
    value: 1500000,
  },
  {
    title: '20 Lakh',
    value: 2000000,
  },
  {
    title: '25 Lakh',
    value: 2500000,
  },
  {
    title: '50 Lakh',
    value: 5000000,
  },
]

export const HEALTH_POLICY_PERIOD_OPTIONS = [
  {
    title: '1 Year',
    value: 1,
  },
  {
    title: '2 Year',
    value: 2,
  },
  {
    title: '3 Year',
    value: 3,
  },
]

export const ANSWER_TYPES = {
  TEXT_DESCRIPTION: 'TEXT_DESCRIPTION',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DOMAIN: 'DOMAIN',
}

export const GENDER_RADIO_OPTIONS = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
]

export const INSURANCE_CATOGORIES = {
  trustTrovity: 'TRUST_TROVITY',
  manualSelection: 'MANUAL_SELECTION',
}

export const OCCUPATION_LIST_ITEMS = [
  {
    label: 'Business Man',
    value: 'BUSINESSMAN',
  },
  {
    label: 'Carpenter',
    value: 'CARPENTOR',
  },
  {
    label: 'Defence',
    value: 'DEFENCE',
  },
  {
    label: 'Farmer',
    value: 'FARMER',
  },
  {
    label: 'House Maker',
    value: 'HOUSEMAKER',
  },
  {
    label: 'House Wife',
    value: 'HOUSEWIFE',
  },
  {
    label: 'Mason',
    value: 'MASON',
  },
  {
    label: 'Private Job',
    value: 'PRIVATE_JOB',
  },
  {
    label: 'Public Job',
    value: 'PUBLIC_JOB',
  },
  {
    label: 'Teacher',
    value: 'TEACHER',
  },
  {
    label: 'Student',
    value: 'STUDENT',
  },
  {
    label: 'Salaried',
    value: 'SALARIED',
  },
  {
    label: 'Retired',
    value: 'RETIRED',
  },
  {
    label: 'Unemployed',
    value: 'UNEMPLOYED',
  },
  {
    label: 'Self Employed',
    value: 'SELF_EMPLOYED',
  },
]

export const MANDATORY_MEMBER_FIELDS = {
  firstName: {
    required: true,
  },
  lastName: {
    required: true,
  },
  dateOfBirth: {
    required: true,
  },
  gender: {
    required: true,
  },
  height: {
    required: true,
  },
  weight: {
    required: true,
  },
  email: {
    required: true,
    regEx: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  },
  phone: {
    required: true,
    regEx: /^\d{10}$/,
  },
  panNumber: {
    required: true,
    regEx: /^[A-Z]{5}\d{4}[A-Z]$/,
  },
  aadharNumber: {
    required: false,
    regEx: /^\d{12}$/,
  },
  addressLine: {
    required: true,
  },
  landmark: {
    required: false,
  },
  city: {
    required: true,
  },
  state: {
    required: true,
  },
  pincode: {
    required: true,
  },
  relation: {
    required: true,
  },
  maritalStatus: {
    required: true,
  },
}

export const RELATION_LIST = [
  {
    label: 'Self',
    value: 'SELF',
  },
  {
    label: 'Father',
    value: 'FATHER',
  },
  {
    label: 'Mother',
    value: 'MOTHER',
  },
  {
    label: 'Brother',
    value: 'BROTHER',
  },
  {
    label: 'Sister',
    value: 'SISTER',
  },
  {
    label: 'Spouse',
    value: 'SPOUSE',
  },
  {
    label: 'Mother-in-law',
    value: 'MOTHER_IN_LAW',
  },
  {
    label: 'Father-in-law',
    value: 'FATHER_IN_LAW',
  },
  {
    label: 'Son',
    value: 'SON',
  },
  {
    label: 'Daughter',
    value: 'DAUGHTER',
  },
  {
    label: 'GrandFather',
    value: 'GRANDFATHER',
  },
  {
    label: 'GrandMother',
    value: 'GRANDMOTHER',
  },
  {
    label: 'StepSon',
    value: 'STEPSON',
  },
  {
    label: 'StepDaughter',
    value: 'STEPDAUGHTER',
  },
]

export const KYC_DATA = {
  done: 'DONE',
  notDone: 'NOT_DONE',
}

export const MARITAL_STATUS_LIST_ITEMS = [
  {
    label: 'Married',
    value: 'MARRIED',
  },
  {
    label: 'Widowed',
    value: 'WIDOWED',
  },
  {
    label: 'Divorced',
    value: 'DIVORCED',
  },
  {
    label: 'Separated',
    value: 'SEPARATED',
  },
  {
    label: 'Single',
    value: 'SINGLE',
  },
]

export const MARITAL_STATUS_TYPE_ENUMS = {
  married: 'MARRIED',
  widowed: 'WIDOWED',
  divorced: 'DIVORCED',
  separated: 'SEPARATED',
  single: 'SINGLE',
}

export const AGE_KEYS = {
  SELF: 'myAge',
  FATHER: 'fatherAge',
  MOTHER: 'motherAge',
  SPOUSE: 'spouseAge',
  MOTHER_IN_LAW: 'motherInLawAge',
  FATHER_IN_LAW: 'fatherInLawAge',
  SON: 'kid',
  DAUGHTER: 'kid',
}

export const CORPORATE_LINKS = [
  {
    label: 'Group Health',
    link: `${process.env.REACT_APP_HOME_URL}/group-health-insurance/`,
  },
  {
    // prettier-ignore
    label: 'Contractor\'s All Risk',
    link: `${process.env.REACT_APP_HOME_URL}/contractors-all-risk-insurance-car/`,
  },
  {
    label: 'Fire',
    link: `${process.env.REACT_APP_HOME_URL}/fire-insurance/`,
  },
  {
    label: 'Marine',
    link: `${process.env.REACT_APP_HOME_URL}/marine-insurance/`,
  },
  {
    label: 'Workmen Compensation',
    link: `${process.env.REACT_APP_HOME_URL}/workmen-compensation-insurance/`,
  },
]

export const PERSONAL_LINKS = [
  {
    label: 'Health',
    link: `${process.env.REACT_APP_LANDING_URL}/individual/dashboard/buyPolicy/health`,
  },
  {
    label: 'Car',
    link: `${process.env.REACT_APP_LANDING_URL}/individual/dashboard/buyPolicy/motor`,
  },
  {
    label: 'Bike',
    link: `${process.env.REACT_APP_LANDING_URL}/individual/dashboard/buyPolicy/bike`,
  },
  {
    label: 'Life',
    link: `${process.env.REACT_APP_HOME_URL}/term-life-insurance/`,
  },
  {
    label: 'Home',
    link: `${process.env.REACT_APP_HOME_URL}/home-insurance/`,
  },
  {
    label: 'Travel',
    link: `${process.env.REACT_APP_HOME_URL}/travel-insurance/`,
  },
]

export const providerIds = {
  goDigit: 'PROV_01',
  zuno: 'PROV_02',
  icici: 'PROV_08',
}

export const CAR_DETAILS_TAB_TYPES = {
  brand: 'BRAND',
  car: 'CAR',
  fuel: 'FUEL',
  model: 'MODEL',
  rtoDetails: 'RTO_DETAILS',
  price: 'PRICE_DETAILS',
  userDetails: 'USER_DETAILS',
}

export const CAR_DETAILS_TABS = [
  {
    type: CAR_DETAILS_TAB_TYPES.brand,
    label: 'Choose Car Brand',
    key: 'brand',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.car,
    label: 'Choose Car',
    key: 'carType',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.fuel,
    label: 'Fuel',
    key: 'fuelType',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.model,
    label: 'Model',
    key: 'model',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.rtoDetails,
    label: 'RTO Location',
    key: 'rtoLocation',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.price,
    label: 'Price Details',
    key: 'exShowroomPrice',
  },
  {
    type: CAR_DETAILS_TAB_TYPES.userDetails,
    label: 'User Details',
    key: 'userFullName',
  },
]

export const CAR_BRANDS_LIST = [
  {
    label: 'Suzuki',
    value: 'SUZUKI',
    icon: Suzuki,
  },
  {
    label: 'Hyundai',
    value: 'HYUNDAI',
    icon: Hyundai,
  },
  {
    label: 'Tata',
    value: 'TATA',
    icon: Tata,
  },
  {
    label: 'Mahindra',
    value: 'MAHINDRA',
    icon: Mahindra,
  },
  {
    label: 'Toyota',
    value: 'TOYOTA',
    icon: Toyota,
  },
  {
    label: 'Kia',
    value: 'KIA',
    icon: Kia,
  },
  {
    label: 'MG',
    value: 'MG',
    icon: MG,
  },
  {
    label: 'Skoda',
    value: 'SKODA',
    icon: Skoda,
  },
  {
    label: 'Volkswagen',
    value: 'VOLKSWAGEN',
    icon: Volkswagen,
  },
  {
    label: 'Honda',
    value: 'HONDA',
    icon: Honda,
  },
  {
    label: 'Jeep',
    value: 'JEEP',
    icon: Jeep,
  },
  {
    label: 'Nissan',
    value: 'NISSAN',
    icon: Nissan,
  },
  {
    label: 'Renault',
    value: 'RENAULT',
    icon: Renault,
  },
  {
    label: 'Mercedes',
    value: 'MERCEDES',
    icon: Mercedes,
  },
  {
    label: 'BMW',
    value: 'BMW',
    icon: BMW,
  },
]

export const CAR_TYPE_LIST = [
  {
    label: 'Alto',
    value: 'ALTO',
  },
  {
    label: 'Zen',
    value: 'ZEN',
  },
  {
    label: 'Baleno',
    value: 'BALENO',
  },
  {
    label: 'Celerio',
    value: 'CELERIO',
  },
  {
    label: 'Alto-800',
    value: 'ALTO_800',
  },
  {
    label: 'Ciaz',
    value: 'CIAZ',
  },
  {
    label: 'Swift',
    value: 'SWIFT',
  },
  {
    label: 'Swift Dzire',
    value: 'SWIFT_DZIRE',
  },
  {
    label: 'Alto K10',
    value: 'ALTO_K10',
  },
  {
    label: 'Ertiga',
    value: 'ERTIGA',
  },
  {
    label: 'Grand Vitara',
    value: 'GRAND_VITARA',
  },
  {
    label: 'Invicto',
    value: 'INVICTO',
  },
  {
    label: 'Fronx',
    value: 'FRONX',
  },
  {
    label: 'Ignis',
    value: 'IGNIS',
  },
  {
    label: 'Jimny',
    value: 'Jimny',
  },
  {
    label: 'XL6',
    value: 'XL6',
  },
]

export const FUEL_TYPE_LIST = [
  {
    name: 'Petrol',
    value: 'PETROL',
  },
  {
    name: 'Diesel',
    value: 'DIESEL',
  },
  {
    name: 'Petrol + CNG/LPG company fitted',
    value: 'PETROL_CNG_COMPANY_FITTED',
  },
  {
    name: 'Petrol + CNG/LPG Fitted after the Purchase',
    value: 'PETROL_CNG_FITTED_AFTER',
  },
]

export const MODEL_OPTIONS = [
  {
    name: '1.2 DLX',
    value: '1.2 DLX',
  },
  {
    name: 'GLAM',
    value: 'GLAM',
  },
  {
    name: 'LXI (1197 cc)',
    value: 'LXI (1197 cc)',
  },
  {
    name: 'VXI (1197 cc)',
    value: 'VXI (1197 cc)',
  },
  {
    name: 'ZXI (1197 cc)',
    value: 'ZXI (1197 cc)',
  },
  {
    name: 'LDI (1197 cc)',
    value: 'LDI (1197 cc)',
  },
  {
    name: 'VDI (1197 cc)',
    value: 'VDI (1197 cc)',
  },
  {
    name: 'ZDI (1197 cc)',
    value: 'ZDI (1197 cc)',
  },
]

export const REGISTRATION_LOCATIONS = [
  {
    name: 'AN-01 Port Blair',
    value: 'AN-01 PORT BLAIR',
  },
  {
    name: 'AN-02 Car Nicobar',
    value: 'AN-02 CAR NICOBAR',
  },
  {
    name: 'AP-01 Nirmal',
    value: 'AP-01 NIRMAL',
  },
  {
    name: 'AP-02 Ananthapur',
    value: 'AP-02 ANANTHAPUR',
  },
  {
    name: 'AP-02 Thirupati',
    value: 'AP-02 THIRUPATI',
  },
  {
    name: 'AN-01 Port Blair',
    value: 'AN-01 PORT BLAIR',
  },
  {
    name: 'AN-01 Port Blair',
    value: 'AN-01 PORT BLAIR',
  },
  {
    name: 'AN-01 Port Blair',
    value: 'AN-01 PORT BLAIR',
  },
  {
    name: 'AN-01 Port Blair',
    value: 'AN-01 PORT BLAIR',
  },
]

export const PLAN_DETAILS_TAB_TYPES = {
  features: 'FEATURES',
  networkHospitals: 'NETWORK_HOSPITALS',
  claims: 'CLAIMS',
  faqs: 'FAQS',
  videos: 'VIDEOS',
}
export const PLAN_DETAILS_TAB_LIST = [
  {
    label: 'Features',
    value: PLAN_DETAILS_TAB_TYPES.features,
    icon: feature,
  },
  {
    label: 'Network Hospitals',
    value: PLAN_DETAILS_TAB_TYPES.networkHospitals,
    icon: networkHospital,
  },
  {
    label: 'Claims',
    value: PLAN_DETAILS_TAB_TYPES.claims,
    icon: claims,
  },
  {
    // prettier-ignore
    label: 'FAQ\'s',
    value: PLAN_DETAILS_TAB_TYPES.faqs,
    icon: FAQ,
  },
  {
    label: 'Videos',
    value: PLAN_DETAILS_TAB_TYPES.videos,
    icon: videos,
  },
]

export const healthCoveragesList = [
  {
    image: inPatient,
    title: 'In-Patient Hospitalization',
    text: 'Covers hospitalization expenses including room charges, doctor fees, and medical procedures.',
  },
  {
    image: outPatient,
    title: 'Out-patient Treatment',
    text: 'Covers expenses for doctor consultations, diagnostic tests, and medications.',
  },
  {
    image: dayCare,
    title: 'Daycare Procedures',
    text: 'Covers medical procedures that do not require overnight hospitalization.',
  },
  {
    image: prePost,
    title: 'Pre and Post Hospitalization',
    text: 'Covers medical expenses incurred before and after hospitalization.',
  },
  {
    image: maternity,
    title: 'Maternity Benefits',
    text: 'Covers maternity-related expenses including prenatal and postnatal care.',
  },
  {
    image: emergencyAmbulance,
    title: 'Emergency Ambulance',
    text: 'Covers the cost of emergency ambulance services.',
  },
]

export const COVERAGE_ITEM_LIST = [
  {
    id: 'topCoverages',
    label: 'Top Coverages',
  },
  {
    id: 'waitingCoverages',
    label: 'Waiting Coverages',
  },
  {
    id: 'valueAddedCoverages',
    label: 'Value Added Coverages',
  },
  {
    id: 'additionalCoverages',
    label: 'Additional Coverages',
  },
]

export const HEALTH_ROUTES = {
  insuranceDetails: 'insuranceDetails',
  planDetails: 'plan-details',
  memberDetailsForm: 'member-details',
  medicalCondition: 'medical-condition',
  termsAndConditions: 'terms-and-conditions',
}

export const NOT_COVERED_ITEMS = [
  {
    id: 'natalExpenses',
    title: 'Pre-Natal & Post-Natal Expenses',
    description:
      'Pre-natal and post-natal medical expenses, unless it leads to hospitalization.',
  },
  {
    id: 'preExistingDiseases',
    title: 'Pre-Existing Diseases',
    description:
      'In case of a pre-existing disease, unless the waiting period is over, the claim for that disease or illness cannot be made.',
  },
  {
    id: 'hospitalizationRecommendation',
    title: 'Hospitalization without Doctor’s Recommendation',
    description:
      'Any condition you get hospitalized for, that doesn’t match with the doctor’s prescription is not covered.',
  },
]

export const TROVITY_ASSURANCE_LIST = [
  {
    id: 'seamlessSupport',
    title: 'Seamless Support During Hospitalization',
    assuranceItems: [
      {
        id: 'closeCoOrdination',
        description: 'Close coordination with healthcare providers',
      },
      {
        id: 'assistance',
        description: 'Assistance with hospitalization process',
      },
    ],
  },
  {
    id: 'minimizeBurden',
    title: 'Minimize Your Financial Burden',
    assuranceItems: [
      {
        id: 'findingHospital',
        description: 'Assistance in finding a suitable hospital for your needs',
      },
      {
        id: 'expertGuidance',
        description: 'Expert guidance to reduce out-of-pocket costs',
      },
    ],
  },
  {
    id: 'comprehensiveAid',
    title: 'Comprehensive Pre and Post Hospitalization Aid',
    assuranceItems: [
      {
        id: 'specializedSupport',
        description:
          'Specialized support for medical expenses before and after hospitalization',
      },
      {
        id: 'documentationGuidance',
        description:
          'Guidance on necessary documentation for specific procedures',
      },
    ],
  },
  {
    id: 'optimalClaiming',
    title: 'Expert Guidance for Optimal Claiming',
    assuranceItems: [
      {
        id: 'choosingRightPolicy',
        description:
          'Assistance in choosing the right policy during a claim, especially when dealing with multiple policies (if you have multiple because of other family members having, provided by office / institution etc.)',
      },
      {
        id: 'tailoredAdvice',
        description:
          'Tailored advice on maximizing your claim benefits and coverage based on your specific situation',
      },
    ],
  },
  {
    id: 'claimCounseling',
    title: 'Claim Counseling: Your Claims Made Easy',
    assuranceItems: [
      {
        id: 'claimSupport',
        description: 'Step-by-step guidance and support for claims',
      },
      {
        id: 'explanations',
        description: 'Clear explanations and assistance throughout the process',
      },
    ],
  },
  {
    id: 'help',
    // prettier-ignore
    title: 'We\'re Here to Help, Insurance or Not: Your Peace of Mind Matters',
    assuranceItems: [
      {
        id: 'commitment',
        description:
          'Our commitment is to ensure your peace of mind throughout the entire process',
      },
    ],
  },
]

export const TIP_LIST = [
  {
    id: 'choice',
    description: (
      <span>
        Don&apos;t get trapped by the allure of 1Cr coverage at dirt-cheap
        premiums; it&apos;s a lifelong commitment.When you age or your earnings
        dwindle,those sky-high premiums become
        <b> Mission Impossible</b> to manage.
        <b> Opt for 5 to 10 Lakhs Health Insurance </b>
        instead-it&apos;s a wise and affordable choice.
      </span>
    ),
  },
  {
    id: 'criticalIllness',
    description: (
      <span>
        If you&apos;re <b>35 or older</b>, it&apos;s wise to think about adding{' '}
        <b>critical illness coverage</b> to your insurance. This gives you a{' '}
        <b>lump sum</b> if you&apos;re diagnosed with{' '}
        <b>specific serious illnesses.</b>
      </span>
    ),
  },
  {
    id: 'coPayment',
    description: (
      <span>
        <b>Understanding Co-payment:</b> If your policy has co-payment, you pay
        a portion of expenses during hospitalization, keeping premiums lower.{' '}
        <b>Opting for no co-payment means slightly higher premiums</b>, but
        lesser out-of-pocket costs during hospitalization.{' '}
        <b>Choose what fits your budget and needs wisely.</b>
      </span>
    ),
  },
  {
    id: 'prioritizePolicies',
    description: (
      <span>
        Paying a slightly higher premium for comprehensive coverage is a wise
        investment in the long run.{' '}
        <b>
          Like prioritize policies with no room/ICU daily limit and automatic
          restoration of sum insured, and initial waiting period of 1-2 years.
        </b>
      </span>
    ),
  },
  {
    id: 'freeHealthCheckup',
    description: (
      <span>
        Look for policies offering <b>free health check-ups</b> every{' '}
        <b>1-2 years</b>. This not only helps monitor your health but also{' '}
        <b>saves you money</b> on <b>regular health assessments</b>.
      </span>
    ),
  },
]

export const GENDER_LIST_NOMINEE = [
  {
    label: 'Male',
    enum: 'MALE',
    icon: Gender_Male,
  },
  {
    label: 'Female',
    enum: 'FEMALE',
    icon: Gender_Female,
  },
  {
    label: 'Other',
    enum: 'OTHER',
  },
]

export const cKYC_LIST = ['PROV_08', 'PROV_10', 'PROV_04']

export const premiumBreakUp_Provider_List = ['PROV_10']

export const POLICY_TENURE_LIST = [
  {
    label: '1 Year',
    value: 1,
  },
  {
    label: '2 Years',
    value: 2,
  },
  {
    label: '3 Years',
    value: 3,
  },
]

export const CURRENT_STATUS = {
  homeScreen: 'HOME_SCREEN',
  quickQuoteReceived: 'QUICK_QUOTE_RECEIVED',
  detailsFilled: 'DETAILS_FILLED',
  fullQuoteReceived: 'FULL_QUOTE_RECEIVED',
  kycSuccessPaymentPending: 'KYC_SUCCESS_PAYMENT_PENDING',
  kycFailedPaymentSuccess: 'KYC_FAILED_PAYMENT_SUCCESS',
  paymentSuccessKycPending: 'PAYMENT_SUCCESS_KYC_PENDING',
  paymentFailedKycPending: 'PAYMENT_FAILED_KYC_PENDING',
  kycSuccessPaymentSuccess: 'KYC_SUCCESS_PAYMENT_SUCCESS',
}

export const INSURANCE_TYPE_CATOGORIES = {
  health: 'HEALTH',
  twoWheeler: 'TWO_WHEELER',
  fourWheeler: 'FOUR_WHEELER',
}

export const RELATION_TYPE_LIST = [
  {
    label: 'Self',
    value: 'SELF',
  },
  {
    label: 'Father',
    value: 'FATHER',
  },
  {
    label: 'Mother',
    value: 'MOTHER',
  },
  {
    label: 'Spouse',
    value: 'SPOUSE',
  },
  {
    label: 'Father-in-Law',
    value: 'FATHER_IN_LAW',
  },
  {
    label: 'Mother-in-Law',
    value: 'MOTHER_IN_LAW',
  },
  {
    label: 'Sister',
    value: 'SISTER',
  },
  {
    label: 'Brother',
    value: 'BROTHER',
  },
  {
    label: 'Son',
    value: 'SON',
  },
  {
    label: 'Daughter',
    value: 'DAUGHTER',
  },
]

export const LIFE_ROUTES = {
  insuranceDetails: 'insuranceDetails',
  planDetails: 'plan-details',
  memberDetailsForm: 'member-details',
  termsAndConditions: 'terms-and-conditions',
}

export const DETAILS = {
  PAN_NUMBER: 'panNumber',
  DOB: 'dateOfBirth',
  INVALID_PAN: 'Invalid PAN format',
  AGE_MUST_18: 'Age must be 18 or older',
}

export const ERROR_ON_QOUTE = 'Encountered an error while comparing quotes.'

export const REMOVE_QOUTE_COMPARISION = 'Remove Quote from Comparison List'

export const PAYMENT = 'payment'

export const KYC = 'kyc'

export const PAYMENT_STATUS =
  'Encountered an error while verifying Payment Status.'

export const FETCHING_ERROR_KYC =
  'Encountered an error while fetching KYC details.'

export const ENCOUNTERED_ERROR_WHILE_SAVING =
  'Encountered an error while saving details.'

export const YES = 'yes'
export const NO = 'no'

export const ERROR_OCCURED_ON_PROPOSAL =
  'An error occurred while fetching proposal data'

export const ERROR_ENCOUNTERED_ON_QOUTE =
  'Encountered an error while fetching full quote details.'

export const ERROR_ON_PAYMNET_INITITATION =
  'Encountered an error while initiating the payment.'

export const QUOTE_404 = 'Could not find full quote details.'

export const vehicleTypes = [
  { option: 'Two Wheeler', value: 'TWO_WHEELER' },
  { option: 'Four Wheeler', value: 'FOUR_WHEELER' },
]

export const VEHICLE_DETAILS =
  'Encountered an error while fetching vehicle details.'

export const SUBMITTEED_WILL_GET_BACK_SOON =
  'Request has been raised successfully. We will get back to you soon'

export const COMPANY = 'company'

export const ERROR_ON_STATE_AND_CITY =
  'Encountered an error while fetching city and state.'

export const ERROR_ON_KYC = 'Encountered an error while verifying kyc.'

export const NO_ADD_ONS_AVALIABLE = 'No add ons available'

export const ERROR_FETCHING_LIST =
  'Encountered an error while fetching add ons list.'

export const radioOptions = [
  {
    label: 'Expired',
    value: 'expired',
    popoverContent: 'Popover content for Option 1',
  },
  {
    label: 'Not Expired',
    value: 'notExpired',
    popoverContent: 'Popover content for Option 2',
  },
]

export const expired = {
  expired: 'expired',
  notExpired: 'notExpired',
}
export const existingClaims = {
  yes: 'yes',
  no: 'no',
}

export const POLICY_TYPES = {
  EXPIRED: 'expired',
  NOT_EXPIRED: 'notExpired',
  OWN_DAMAGE: 'OWN_DAMAGE',
}
export const KUTTI = 'kutti'

export const FILL_REQ_FIELDS = 'Please fill out the required fields.'

export const ERROR_ON_LOAN_PROVIDER =
  'Encountered an error while fetching loan providers list.'

export const PROVIDER_LIST =
  'Encountered an error while fetching Insurance Providers List.'

export const NICKNAME = 'nickName'

export const INVALID_LICENSE = 'Invalid license plate format'

export const VALID_VEHICLE_NUMBER = 'Please Enter A Valid Vehicle Number'

export const VALID_VH_NUMBER = 'Please Enter The Vehicle Number'

export const PLEASE_FILL_DETAILS = 'Please fill vehicle details'

export const ERROR_ON_FETCHING_VARIANT_LIST =
  'Encountered an error while fetching Variant list.'

export const ERROR_ON_FETCHING_MODEL_LIST =
  'Encountered an error while fetching model list.'

export const ERROR_ON_FETCHING_BRAND_LIST =
  'Encountered an error while fetching brand list.'

export const ERROR_ON_FETCHING_FEULTYPE_LIST =
  'Encountered an error while fetching fuel type list.'

export const VEHICLE_VARIANT = {
  BRAND: 'brand',
  MODEL: 'model',
  VARIANT: 'variant',
  FUELTYPE: 'fuelType',
}

export const USERIDV = 'usersIdv'
